import {
  GLOBAL_REPORT_GOAL_ACHIEVED_COLOR,
  GLOBAL_REPORT_GOAL_REMAINING_COLOR,
} from "./globalReportChartPalette";

const SEGMENT_ACHIEVED = "achieved";
const SEGMENT_REMAINING = "remaining";

/**
 * Progress bar dataset: achieved vs remaining toward monthly volume.
 */
export const buildGlobalReportGoalsProgressDonutDataset = ({
  achieved = 0,
  volume = 0,
}) => {
  const achievedN = Math.max(0, Number(achieved) || 0);
  const targetN = Math.max(0, Number(volume) || 0);
  const remaining = Math.max(0, targetN - achievedN);
  const exceededBy = achievedN > targetN ? achievedN - targetN : 0;

  const displayAchieved =
    targetN > 0 ? Math.min(achievedN, targetN) : achievedN;

  const percent =
    targetN > 0
      ? Math.min(100, Math.round((achievedN / targetN) * 100))
      : achievedN > 0
        ? 100
        : 0;

  const barAchieved = displayAchieved;
  const barRemaining = targetN > 0 ? remaining : 0;

  const chartData =
    achievedN > 0 || targetN > 0
      ? [
          {
            label: "",
            [SEGMENT_ACHIEVED]: barAchieved,
            [SEGMENT_REMAINING]: barRemaining,
          },
        ]
      : [];

  return {
    chartData,
    chartConfig: {
      [SEGMENT_ACHIEVED]: {
        label: SEGMENT_ACHIEVED,
        color: GLOBAL_REPORT_GOAL_ACHIEVED_COLOR,
      },
      [SEGMENT_REMAINING]: {
        label: SEGMENT_REMAINING,
        color: GLOBAL_REPORT_GOAL_REMAINING_COLOR,
      },
    },
    achieved: achievedN,
    volume: targetN,
    percent,
    exceededBy,
    hasData: achievedN > 0 || targetN > 0,
    isComplete: targetN > 0 && achievedN >= targetN,
  };
};

export default buildGlobalReportGoalsProgressDonutDataset;
